module.exports = __webpack_public_path__ + "static/img/062_TO8_1620.1be9d4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/062_TO8_1620.jpg
// module id = 34Dy
// module chunks = 0